import styled from "@emotion/styled"
import tw from "twin.macro"

export const InfoWindow = styled.div<InfoWindowProps>`
  ${tw`relative -left-14 w-30 max-h-18 md:max-h-22 bg-white z-50 flex items-center justify-center flex-col`} ::after {
    content: "";
    transform: translate(0, -50%) rotate(45deg);
    ${tw`absolute w-1-6 h-1-6 bg-white z-50 -bottom-1-6`}
  }
  ${({ height }) => (height > 0 ? `bottom: ${height + 40}px` : tw`bottom-22`)}
`

export const InfoInner = tw.div`relative flex flex-col justify-between w-full h-full overflow-y-auto p-2`

export const Title = tw.h3`
  text-14 font-body font-medium w-4/5
`

export const Content = styled.div`
  ${tw`w-full`}
  p {
    ${tw`text-12 font-body leading-1.56 mb-0`}
  }
`

export const ContentHours = tw.div`w-full flex justify-between`

export const Space = tw.div`w-full h-1 mb-0-2`

export const Text = styled.p<TextProps>`
  ${tw`text-12 font-body leading-1.56`}
  ${({ full }) => (full === "true" ? tw`w-full` : tw`w-2/3`)}
  ${({ hover }) => (hover === "true" ? tw`hover:text-red` : null)}
  ${({ bold }) => (bold === "true" ? tw`font-medium` : null)}
`

export const StyledIconWrapper = tw.div`absolute top-2 right-2 cursor-pointer`

type TextProps = {
  full?: "true" | "false"
  hover?: "true" | "false"
  bold?: "true" | "false"
}

type InfoWindowProps = {
  height: number
}

export const GOOGLE_MAP_STYLE = [
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#c4eced",
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        color: "#f9f9f9",
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#f9e4d8",
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#f9e4d8",
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        color: "#dfd8cf",
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      {
        color: "#dfd8cf",
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5",
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#b6e5d0",
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#ffffff",
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        saturation: 36,
      },
      {
        color: "#333333",
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      {
        color: "#f2f2f2",
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#fefefe",
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#fefefe",
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
]
